import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import PageForm from 'components/settings/Pages/Forms/PageForm';
import AdminLayout from 'components/layout/AdminLayout';
import Header from 'components/layout/Partials/Header';
import { Box, Button, Divider } from '@material-ui/core';
import clsx from 'clsx';
import Section from 'components/UI/Section';
import { useHistory, useParams } from 'react-router-dom';
import { defaultStyles } from 'utils/Theme';
import { showSnackbar } from 'redux/alerts/actions';
import { useDispatch, useSelector } from 'react-redux';
import api from 'api';
import { qsServerSelector } from 'redux/qsServer/selector';
import { getSaasSpaces } from 'components/settings/Pages/helper';
import { logoutUser } from 'redux/actions/authActions';
import { convertSpaces } from 'utils/selectConversions';
import { qlikAppsDropdownSelector } from 'redux/qlik/selectors';
import { getQlikApps } from 'redux/actions/qlikActions';
import config from 'coeus.config';
import { qlikClient } from 'constants/environmental';
import { getMasterApps } from 'redux/actions/dagActions';
import { masterAppsDropdownSelector } from 'redux/adag/selectors';
import { getPages } from 'redux/actions/pagesActions';
import { pagesDropdownSelector } from 'redux/pages/selectors';

const SAAS = config.saas_client === qlikClient.SAAS;

const defaultInitialValues = {
    title: '',
    qsApp: '',
    masterApp: '',
    status: 'draft',
    parent: '0',
    icon: 'ChevronRight',
    sortOrder: 0,
    publicAccess: false,
    menu: 'no',
    space: '',
    source: config.saas_client,
    valpakSSO: false,
};

const PageFormContainer = ({ updateForm, edit, submitText }) => {
    const { id } = useParams();
    const [title, setTitle] = useState('');
    const [initialValues, setInitialValues] = useState(null);
    const [spaces, setSpaces] = useState(null);
    const [space, setSpace] = useState(null);
    const server = useSelector(qsServerSelector);
    const qsApps = useSelector(qlikAppsDropdownSelector);
    const masterApps = useSelector(masterAppsDropdownSelector);
    const pages = useSelector(pagesDropdownSelector);
    const classes = defaultStyles();
    const history = useHistory();
    const dispatch = useDispatch();

    const loadSpaces = async () => {
        const response = await getSaasSpaces(server).catch((err) => {
            if (err.status === 401) {
                dispatch(logoutUser());
            }
        });
        if (response?.data) setSpaces(convertSpaces(response.data));
    };

    const loadPage = () => {
        api.pages
            .get(id)
            .then((results) => {
                setInitialValues(results);
                if (results.title) setTitle(results.title);
            })
            .catch((err) => {
                console.error(err);
                dispatch(
                    showSnackbar({
                        open: true,
                        severity: 'error',
                        message: 'Failed to load Page',
                    })
                );
            });
    };

    useEffect(() => {
        if (initialValues?.space) {
            setSpace(initialValues.space);
        }
    }, [initialValues]);

    useEffect(() => {
        dispatch(getQlikApps(space));
    }, [space]);

    useEffect(() => {
        if (server) {
            if (SAAS) loadSpaces();
        }
    }, [server]);

    useEffect(() => {
        dispatch(getQlikApps());
        dispatch(getPages());

        if (!SAAS) dispatch(getMasterApps());

        if (id) {
            loadPage();
        } else {
            setInitialValues(defaultInitialValues);
        }
    }, []);

    const heading = edit ? `Edit ${title}` : `Create New Page`;

    return (
        <AdminLayout>
            <div className="o-page">
                <Header hideSearchBar title={'Edit Page'} />
                <Box className={clsx('u-m-xsmall ')}>
                    <Section>
                        <Box className="u-p-small full_height">
                            <div className={'u-m-zero'}>
                                <div className="o-line u-mv-small">
                                    <div>
                                        <h4 className={`c-card__title `}>
                                            {heading}
                                        </h4>
                                    </div>
                                    <div>
                                        <Button
                                            className={`${classes.buttonSecondary}`}
                                            onClick={(e) => history.goBack()}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </div>
                                <Divider className={'u-mv-medium'} />
                                <div>
                                    {initialValues && (
                                        <PageForm
                                            initialValues={initialValues}
                                            updateForm={updateForm}
                                            spaces={spaces}
                                            qsApps={qsApps}
                                            setSpace={setSpace}
                                            masterApps={masterApps}
                                            pages={pages}
                                            submitText={submitText}
                                        />
                                    )}
                                </div>
                            </div>
                        </Box>
                    </Section>
                </Box>
            </div>
        </AdminLayout>
    );
};

export default PageFormContainer;

PageFormContainer.propTypes = {
    edit: PropTypes.bool,
    updateForm: PropTypes.func.isRequired,
};

PageFormContainer.defaultProps = {
    edit: true,
};
